import type { FilterOption } from '@shared/ui/filters/lib/types';

export const normalizeOptions = (option: any): FilterOption[] => {
  const arr = Array.isArray(option) ? option : [option];

  return arr
    .map((o) => {
      const anyOpt = o as any;
      const value = anyOpt.value ?? anyOpt.id ?? anyOpt.key ?? null;

      if (value == null) return null;

      return {
        label: anyOpt.label ?? anyOpt.title ?? String(value),
        value,
      } as FilterOption;
    })
    .filter((x): x is FilterOption => x !== null);
};
